import Vue from "vue";
import Vuex from "vuex";
import parcours from "./modules/parcours.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    base_url: "https://sportips.fr/api/v1/unique_event/endpoints",
    module: {

    },
    map_settings: {
      mode: [
        { name: "topo", link: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png" },
        { name: "terrain", link: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" },
        { name: "map", link: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" },
      ],
      selected_mode: 0,
    },
    refreshIntervals: [],
    refreshTempsCourseIntervals: [],
    loading: false,
    showParticipantsTab: true,
    live_en_cours: true,
    selected_live_course: "",
    last_live_tab: "participants",
    refresh_time_live: 20000,
    refresh_time_carte: 20000,
    date_selected_course: "",
    heure_selected_course: "",
    fin_selected_course: "NON",
    logged: false,
  },
  mutations: {
    initModule(state, m) {
      state.module = m;
    },
    initAdmin(state, a) {
      state.admin = a;
    },
    setParcours(state, p) {
      state.module.list_parcours = p;
    },
    setInscriptions(state, i) {
      state.module.list_inscriptions = i;
    },
    setResultats(state, r) {
      state.module.resultats = r;
    },
    setLive(state, l) {
      state.module.live = l;
    },
    setLoading(state) {
      state.loading = true;
    },
    unsetLoading(state) {
      state.loading = false;
    },
    setFondCarte(state, f) {
      state.map_settings.selected_mode = f;
    },
    clearRefreshIntervals(state) {
      for (var i = 0; i < state.refreshIntervals.length; i++) {
        clearInterval(state.refreshIntervals[i]);
      }
      state.refreshIntervals = [];
    },
    clearRefreshTempsCourseIntervals(state) {
      for (var i = 0; i < state.refreshTempsCourseIntervals.length; i++) {
        clearInterval(state.refreshTempsCourseIntervals[i]);
      }
      state.refreshTempsCourseIntervals = [];
    },

    set_refresh_time_live(state, t) {
      state.refresh_time_live = parseInt(t) * 1000;
    },
    set_refresh_time_carte(state, t) {
      state.refresh_time_carte = parseInt(t) * 1000;
    },
  },
  actions: {},
  modules: {
    parcours,
  },
});
